import { IFaireAcademyChapter } from '@faire/web-api--source/indigofair/data/IFaireAcademyChapter';

export namespace IFaireAcademyGuide {
  export enum GuideIdentifier {
    GUIDE_IDENTIFIER_UNKNOWN = 'GUIDE_IDENTIFIER_UNKNOWN',
    LAY_THE_GROUNDWORK = 'LAY_THE_GROUNDWORK',
    GET_FUNDING_AND_LICENSES = 'GET_FUNDING_AND_LICENSES',
    FIND_A_RETAIL_LOCATION = 'FIND_A_RETAIL_LOCATION',
    RENOVATE_YOUR_STORE = 'RENOVATE_YOUR_STORE',
    PLAN_AND_BUY_INVENTORY = 'PLAN_AND_BUY_INVENTORY',
    ORGANIZE_YOUR_OPERATIONS = 'ORGANIZE_YOUR_OPERATIONS',
    PROMOTE_YOUR_STORE = 'PROMOTE_YOUR_STORE',
  }

  /**
   * Return an instance of IFaireAcademyGuide with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IFaireAcademyGuide>
  ): IFaireAcademyGuide =>
    ({
      chapters: [],
      ...(partial ?? {}),
    }) as IFaireAcademyGuide;
}

export interface IFaireAcademyGuide {
  identifier: keyof typeof IFaireAcademyGuide.GuideIdentifier | undefined;
  chapters: Array<IFaireAcademyChapter>;
  likes: number | undefined;
  guide_url: string | undefined;
  title: string | undefined;
  featured_image_url: string | undefined;
}
